const QuoteFormWrapper = ({ children }) => (
  <div className="tw-animate-modal-fade-in tw-w-full">
    <div className="tw-w-full tw-rounded-[14px] tw-border tw-border-solid tw-border-dis-border tw-bg-white tw-px-5 tw-py-5 md:tw-px-8 md:tw-py-8">
      {children}
    </div>
  </div>
);

export default QuoteFormWrapper;
